module.exports = __webpack_public_path__ + "img/zwt.4f30240f.gif";